<template>
  <div>
    <tk-flex middle between class="p-b-20">
      <publicHeader showBack :title="storeDetail.fullName"></publicHeader>
    </tk-flex>
    <div style="background:#fff">
      <a-spin :spinning="spinning">
        <Layout
          :showMenu="true" :menuList="menuList" :defaultKeys="defaultKeys"
          :activeKey.sync="key"
          :mainImage="true"
          :mainImageUrl="storeDetail.storePhoto && storeDetail.storePhoto.length ? storeDetail.storePhoto[0] : ''"
        >
          <template slot="content">
            <div class="full-width full-height" style="color:#363B45" v-if="key === 0 && can('inventoryStoreModel') && storeDetail.status === 'pass'">
              <tk-flex between middle style="paddingBottom: 18px;">
                <div style="color:#363B45;font-weight: 700;font-size: 14px;">铺货库存</div>
              </tk-flex>
              <ak-model-table style="width:100%" model="menuDistributionStockDetail" ref="distributionStock" :filters="filters" :perPage="20" tableSize="small"/>
            </div>
          </template>
        </Layout>
      </a-spin>
    </div>
    <createDistributionStock v-if="showCreateStock" :store="id" :agent="storeDetail.agent.objectId" @complete="() => { showCreateStock = false }" @refresh="()=>{ refreshStock() }"></createDistributionStock>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'
import Layout from '../components/layout.vue'
import createDistributionStock from '../store/component/createDistributionStock.vue'
export default {
  components: {
    publicHeader,
    Layout,
    createDistributionStock
  },
  data () {
    return {
      filters: {},
      id: '',
      storeDetail: {},
      key: 0, // 当前选中的key
      defaultKeys: [0],
      menuList: [
        {
          name: '铺货库存'
        }
      ],
      spinning: true,
      showCreateStock: false
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.filters = {
      store: this.id,
      isDelete: { $ne: true },
      stockNum: {
        $gt: 0
      }
    }
    this.init()
  },
  methods: {
    async init () {
      try {
        let { data: res } = await this.$tkParse.get(`/classes/store/${this.id}`, {
          params: {
            include: 'user,salesman,agent,storeLevel,storeStarRating'
          }
        })
        this.storeDetail = res
        this.spinning = false
      } catch (e) {}
    },
    async refreshStoreDetail () {
      this.spinning = true
      this.showStoreEdit = false
      await this.init()
    },
    refreshStock () {
      this.$refs.distributionStock.refresh()
    },
    // 同步商品
    async syncProducts () {
      try {
        this.spinning = true
        let { data: res } = await this.$tkParse.post('/store/syncProduct', {
          storeId: this.id
        })
        if (res.code !== 'success') {
          throw new Error(res.msg)
        }
        this.spinning = false
        this.$notification['success']({
          message: '操作成功',
          description: '同步成功'
        })
        this.refreshStock()
      } catch (e) {
        this.spinning = false
        this.$notification['error']({
          message: '网络错误',
          description: '同步失败'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .ant-form-item {
    flex-grow: 1;
    margin-bottom: 0;
    padding-bottom: 0;
    .ant-form-item-control-wrapper{
      width: 100%;
    }
    .ant-form-item-label{
      padding-top: 4px;
    }
  }
  .array-img-input-wrap{
    .ignore-item {
      display: none;
    }
  }
}
.createStock{
  ::v-deep{
    .ant-btn{
      color: #FF2A58;
      border-radius: 6px;
      border: 1px solid #FF2A58;
    }
  }
}
</style>
